import { API_BASE_URL, apiGet } from '@/api/http';

import type { EmploymentType } from '@/types/employmentType';

export const getEmploymentTypeList = () =>
  apiGet<EmploymentType[]>(`${API_BASE_URL}employment-types/`);
